<ion-header mode="md" class="ion-no-border">
  <ion-toolbar mode="md" color="getm-primary-default" class="zoom-toolbar">
    <section slot="start">
      <getm-button
        icon="arrow-back"
        color="white"
        shape="round"
        (btnClick)="onDismiss()"
      ></getm-button>
    </section>
  </ion-toolbar>
</ion-header>

<ion-content
  color="getm-background-light-blue"
  [forceOverscroll]="false"
  [scrollY]="false"
  class="zoom-content"
>
  <swiper-container
    #swiperZoom
    class="slides-zoom"
    [zoom]="true"
    zoom-max-ratio="5"
    zoom-min-ratio="1"
    (swiperafterinit)="ionSlidesDidLoad()"
  >
    <swiper-slide class="zoom-slide">
      <div class="swiper-zoom-container">
        <img [src]="Imagen" alt="" class="zoom-image" />
      </div>

      <ion-spinner
        name="crescent"
        color="primary"
        class="spinner"
        *ngIf="spinner"
      ></ion-spinner>
    </swiper-slide>
  </swiper-container>
</ion-content>
